<template>
  <b-card>
    <b-form @submit="addNews">
      <b-row>
        <b-col sm="12">
          <b-form-group label="Title *" label-for="title">
            <b-form-input id="title" v-model="form.title" required />
          </b-form-group>
        </b-col>

        <!-- <b-col sm="12" lg="6">
            <b-form-group label="Author *" label-for="author">
              <b-form-input id="author" v-model="form.author" required />
            </b-form-group>
          </b-col> -->

        <b-col sm="12" lg="6">
          <b-form-group label="Publish" label-for="published">
            <b-form-checkbox
              id="published"
              v-model="form.publish"
              :unchecked-value="false"
              switch
            />
          </b-form-group>
        </b-col>

        <b-col sm="12" class="mb-3">
          <b-form-group label="Content" label-for="content">
            <quill-editor
              v-model="form.content"
              id="content"
              :options="snowOption"
            />
          </b-form-group>
        </b-col>

        <b-col sm="12">
          <div class="mb-1">
            Image
            <span class="text-muted font-italic">(Ratio 16:9 atau 1280px x 720px)</span>
          </div>
          <div id="dropzone-news-image" class="dropzone dropzone-area mb-3">
            <div class="dz-message">
              Drop files here or click button to upload. <br />(Max. size 2MB)
            </div>
          </div>
        </b-col>

        <b-col class="d-flex justify-content-end">
          <b-button type="button" class="mr-1" variant="light">
            Cancel
          </b-button>
          <b-button type="submit" :disabled="isLoading" variant="primary">
            Save
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BCard,
  BFormInput,
  BButton,
  BForm,
  BFormCheckbox,
} from 'bootstrap-vue'
import { quillEditor } from 'vue-quill-editor'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BCard,
    BFormInput,
    BButton,
    BForm,
    BFormCheckbox,
    quillEditor,
  },

  data() {
    return {
      isLoading: false,
      snowOption: {
        theme: 'snow',
      },
      dzInstance: null,
      form: {
        title: '',
        // author: '',
        image: '',
        content: '',
        publish: false,
      },
    }
  },

  mounted() {
    this.initDropzone()
  },

  destroyed() {
    this.dzInstance.disable()
  },

  methods: {
    initDropzone() {
      const options = {
        url: `${process.env.VUE_APP_API_HOST}/api/news-image`,
        maxFiles: 1,
        autoProcessQueue: true,
        autoQueue: true,
        addRemoveLinks: true,
        acceptedFiles: 'image/jpeg,image/jpg',
        headers: {
          Authorization: `Bearer ${this.$store.getters['oauth/getToken']}`,
        },
      }
      const { drawLogoImage, deleteTempFile } = this

      this.dzInstance = new window.Dropzone('#dropzone-news-image', {
        ...options,
        init() {
          this.on('success', (file, res) => drawLogoImage(res.data))
          this.on('removedfile', () => deleteTempFile())
        },
      })
    },

    drawLogoImage(imagePath) {
      this.form.image = imagePath
    },

    deleteTempFile() {
      const deleteFileTempUrl = '/settings/logo-delete'

      this.$http
        .post(deleteFileTempUrl, {
          path: this.form.image,
        })
        .then(() => {
          this.form.image = ''
        })
        .catch(({ data }) => {
          this.$notif('Error', `${data.message}`, 'error')
        })
    },

    addNews(event) {
      event.preventDefault()
      this.isLoading = true

      this.$http
        .post('/news', {
          ...this.form,
        })
        .then(() => {
          this.$notif('Success', 'News has been successfully added.', 'success')
          this.$router.push({ name: 'admin-news' })
        })
        .catch(({ data }) => {
          this.$notif('Error', `${data.message}`, 'error')
        })
        .finally(() => {
          this.isLoading = false
        })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/quill.scss';
</style>

<style scoped>
/deep/ .ql-container {
  height: 200px;
}
</style>
